import styled from "styled-components";
export const BubbleRowWrapper = styled.div``;
